import {Pipe, PipeTransform} from '@angular/core';


// Example <div [innerHtml]="text | highlighted : searchText"></div>
@Pipe({
    name: 'highlighted',
    standalone: false
})
export class HighlightedPipe implements PipeTransform {
  transform(value: string, text): string {
    const regex = new RegExp('(' + text + ')', 'gi');
    return value.replace(regex, '<span class="u-text-highlight">$1</span>');
  }
}
